import React from 'react';

import { noop } from 'lodash';

import ChatInput from '~/components/ChatInput/ChatInput';
import ChatQuestionButton from '~/components/Claim/ChatQuestionButton';
import CliveAvatar from '~/core/iconComponents/special/CliveAvatar';
import cn from '~/utils/cn';

interface UpperChatPanelProps {
  userName?: string;
  onSubmit?: (text: string) => void;
}

const UpperChatPanel: React.FC<UpperChatPanelProps> = ({ userName = '', onSubmit = noop }) => {
  const questions = [{ text: 'Summarize the claim for me' }, { text: 'Show me all recent actions in this claim' }];
  const [value, setValue] = React.useState('');
  const handleQuestionClick = React.useCallback(
    (text: string) => {
      setValue(text);
      onSubmit?.(text);
    },
    [onSubmit]
  );

  return (
    <div className="__CHAT_PANEL_CONTAINER__ flex items-center justify-center bg-cover py-20">
      <div className="__CHAT_PANEL_CENTER__ mx-40 flex max-w-3xl flex-col items-center justify-start gap-24">
        <div className="__CHAT_HEADER_CONTAINER__ flex">
          <div className="__CLIVE_ICON__">
            <CliveAvatar className="mr-12 h-40 w-40 fill-none" />
          </div>
          <div className="__TITLE_AND_DESCRIPTION_CONTAINER__ flex flex-col gap-2">
            <div className="__TITLE__ text-lg font-semibold">{`Hello ${userName}`}</div>
            <div className="__DESC__ text-base font-normal">
              To ask me anything about this claim, or to access related communications and documents—just select the
              claim context using the "@" icon in the input field.
            </div>
          </div>
        </div>

        <div className="__CHAT_INPUT_CONTAINER__ w-full">
          <ChatInput
            value={value}
            rows={1}
            onTextChange={(e) => setValue(e.target.value)}
            onSubmit={onSubmit}
            className={cn('__CHAT_INPUT__ w-full')}
            placeholder="ask me anything..."
          />
        </div>
        <div className="__CHAT_FOOTER__ flex gap-8">
          {questions.map((question, index) => (
            <ChatQuestionButton key={index} text={question.text} onClick={() => handleQuestionClick(question.text)} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpperChatPanel;
